import React, { useCallback, useContext, useEffect, useState } from "react";
import api from "../api";
import { PermsContext } from "../perms";

const statusPill = (s) => {
  const cls = s === "Approved" ? "ok" : s === "Rejected" ? "danger" : "warn";
  return <span className={`pill ${cls}`}>{s}</span>;
};
const fmt = (d) => (d ? new Date(d).toLocaleString("en-GB") : "—");

export default function Workflow() {
  const { actions: can } = useContext(PermsContext);
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("Pending");
  const [open, setOpen] = useState(null); // request being viewed

  const load = useCallback(async () => {
    const r = await api.get("/workflow/requests", { params: status ? { status } : {} });
    setRows(r.data?.data || []);
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const decide = async (r, decision) => {
    const note = decision === "Rejected" ? (window.prompt("Reason for rejection:") ?? "") : (window.prompt("Approval note (optional):") ?? "");
    try {
      const res = await api.post(`/workflow/requests/${r.id}/decide`, { decision, note });
      alert(res.data?.message || "Done"); setOpen(null); load();
    } catch (e) { alert(e?.response?.data?.message || "Failed"); }
  };

  let payload = {};
  if (open) { try { payload = open.payload ? JSON.parse(open.payload) : {}; } catch { payload = {}; } }

  return (
    <div>
      <h1>Approval Inbox</h1>
      <p className="sub">Maker-checker requests — review proposed changes and approve or reject.</p>

      <div className="card">
        <div className="toolbar">
          <select style={{ maxWidth: 180 }} value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="Pending">Pending</option><option value="Approved">Approved</option><option value="Rejected">Rejected</option><option value="">All</option>
          </select>
          <span style={{ color: "#64748b", fontSize: 13 }}>{rows.length} request(s)</span>
        </div>
        <div className="tablewrap">
          <table>
            <thead><tr><th>#</th><th>Module</th><th>Action</th><th>Title</th><th>Requested by</th><th>When</th><th>Status</th><th style={{ width: 220 }}></th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.id}</td><td>{r.module}</td>
                  <td><span className="pill">{r.action}</span></td>
                  <td style={{ maxWidth: 260, whiteSpace: "normal" }}>{r.title || "—"}</td>
                  <td>{r.requested_by}</td><td>{fmt(r.requested_at)}</td><td>{statusPill(r.status)}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <button className="btn link sm" onClick={() => setOpen(r)}>View</button>
                    {r.status === "Pending" && can.approve && <>
                      <button className="btn link sm" onClick={() => decide(r, "Approved")}>Approve</button>
                      <button className="btn link sm danger" onClick={() => decide(r, "Rejected")}>Reject</button>
                    </>}
                  </td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={8}><div className="empty">No requests.</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {open && (
        <div className="overlay" onMouseDown={(e) => e.target === e.currentTarget && setOpen(null)}>
          <div className="modal">
            <h3>Request #{open.id} — {open.module} / {open.action}</h3>
            <div style={{ color: "#64748b", fontSize: 13, marginBottom: 8 }}>
              {open.title}<br />by {open.requested_by} · {fmt(open.requested_at)} · {open.status}
              {open.checker && <> · decided by {open.checker} {fmt(open.decided_at)}</>}
            </div>
            {open.decision_note && <div style={{ marginBottom: 8 }}><b>Note:</b> {open.decision_note}</div>}
            <div style={{ fontWeight: 700, margin: "6px 0" }}>Proposed values</div>
            <div className="tablewrap">
              <table><tbody>
                {Object.entries(payload).map(([k, v]) => (
                  <tr key={k}><td style={{ color: "#64748b", width: 200 }}>{k}</td><td>{v === true ? "Yes" : v === false ? "No" : String(v ?? "—")}</td></tr>
                ))}
                {!Object.keys(payload).length && <tr><td className="empty">No payload (e.g. a delete request).</td></tr>}
              </tbody></table>
            </div>
            <div className="foot">
              <button className="btn" onClick={() => setOpen(null)}>Close</button>
              {open.status === "Pending" && can.approve && <>
                <button className="btn danger" onClick={() => decide(open, "Rejected")}>Reject</button>
                <button className="btn primary" onClick={() => decide(open, "Approved")}>Approve</button>
              </>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
